import { Component, OnInit, Input } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { GenericFilterModel } from '../../security/QueryStringParam';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { Config, Investment, Year } from '../../../shared/model/interfaces';
import { DictionaryPipe } from '../../../shared/pipes/dictionary.pipe';
import { AuthService, GridConfigItem } from '../../../shared/service/auth.service';
import {getErrorMessageText} from '../../helper';

@Component({
  selector: 'app-investment-detail',
  templateUrl: './investment-detail.component.html',
  styleUrls: ['./investment-detail.component.css'],
  providers: [DictionaryPipe]
})
export class InvestmentDetailComponent implements OnInit {
  @Input() investment: Investment;
  years: Year[] = [];
  activeInvSection = 'DT'; // DST//TR

  totalRecords: number;
  public loading: boolean;
  public rowPerPage = 50;
  skipRecords = 0;

  // Transaction
  transSelYear: number;
  transSelTransType: string;
  distributionType = '';
  transactionData = [];

  transactionTypeList: any[] = [{Key: '', Title: ''}];
  distributionTypeList: any[] = [{Key: '', Title: ''}];

  display: boolean;
  popupMessage: string;

  public currentPageNoTrans = 1;
  public sortTrans: SortDescriptor[];
  // Distribution
  public configTransaction: Config;
  public configDistribution: Config;

  distributionsData = [];
  distSelYear: number;
  destYTDDistribution = 0;
  destTotalDistribution = 0;
  destYTDRedemption = 0;
  destTotalRedemption = 0;
  public currentPageNoDist = 1;
  public sortDist: SortDescriptor[];
  // Details
  investorBkrInfo = {};
  private allDataLoadedTrans = false;
  private allDataLoadedDist = false;

  constructor(private abstractDataProvider: AbstractDataProvider,
              private ngxService: NgxUiLoaderService,
              private authService: AuthService,
              private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    this.distributionTypeList.push(...this.authService.distributionCodes.map(x => ({Key: x.Code, Title: x.Description})));
    this.transactionTypeList.push(...this.authService.transactionCodes.map(x => ({Key: x.Code, Title: x.Description})));


    this.configTransaction = this.authService.getGridColumnConfigs(GridConfigItem.INVESTOR_TRANSACTION);
    if (this.configTransaction.allowSort) {
      this.sortTrans = [this.configTransaction.defaultSort];
    }

    this.configDistribution = this.authService.getGridColumnConfigs(GridConfigItem.INVESTOR_DISTRIBUTION);
    if (this.configDistribution.allowSort) {
      this.sortDist = [this.configDistribution.defaultSort];
    }

    this.setInvestmentSection('DT');
    this.destYTDDistribution = this.investment.YTD_DIST_AMT;
    this.destTotalDistribution = this.investment.VTD_DIST_AMT;
    this.destYTDRedemption = this.investment.YTD_RA_AMT;
    this.destTotalRedemption = this.investment.VTD_RA_AMT;
    const years = new Array(Number.parseInt(this.investment.INVESTMENT_END_YEAR) - Number.parseInt(this.investment.INVESTMENT_START_YEAR) + 1)
      .fill(0)
      .map((_, i) => i + Number.parseInt(this.investment.INVESTMENT_START_YEAR))
      .map(y => ({Title: y.toString(), Year: y.toString()})).reverse();
    this.years = [{Title: 'All', Year: '0'}, ...years];
  }

  setInvestmentSection(arg) {
    this.activeInvSection = arg;
    if (arg == 'TR') {
      if (!this.allDataLoadedTrans && !this.loading) {
        this.skipRecords = this.transactionData.length;
        this.loading = true;
        this.getTransactionDetails();
      }
    } else if (arg == 'DST') {
      if (!this.allDataLoadedDist && !this.loading) {
        this.skipRecords = this.distributionsData.length;
        this.loading = true;
        this.getDistributionDetails();
      }
    } else {
      this.getInvestmentDetails();
    }
  }

  sortChangeTrans(sort: SortDescriptor[]): void {
    if (sort && sort[0].field == 'seqNum') {
      return;
    }
    this.sortTrans = sort;
    this.loading = true;
    this.clearTransactionData();
    this.getTransactionDetails();
  }

  filterChangeTrans(): void {
    this.loading = true;
    this.clearTransactionData();
    this.getTransactionDetails();
  }

  loadMoreTrans(event: any) {
    if (!this.allDataLoadedTrans && !this.loading) {
      this.skipRecords = this.transactionData.length;
      this.loading = true;
      this.getTransactionDetails();
    }
  }

  getTransactionDetails() {
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];
    genericFilterModel.Filters.push({Key: 'RollUp2', Value: this.investment.ROLLUP_SUB_2});
    genericFilterModel.Filters.push({Key: 'TransactionType', Value: this.transSelTransType});

    if (this.transSelYear && Number(this.transSelYear)) { // if we send 0, BE will return nothing
      genericFilterModel.Filters.push({Key: 'year', Value: this.transSelYear.toString()});
    }
    const obj = {
      RollUp2: this.investment.ROLLUP_SUB_2,
      TransactionType: this.transSelTransType
    };
    genericFilterModel.PageNo = this.currentPageNoTrans;
    genericFilterModel.PageSize = this.rowPerPage;
    genericFilterModel.SortField = this.sortTrans[0].field;
    genericFilterModel.SortOrder = this.sortTrans[0].dir;
    genericFilterModel.SkipRecords = this.skipRecords;
    this.abstractDataProvider.postData(genericFilterModel, 'api/Investment/GetTransactionRecords')
      .subscribe((investment) => {

          this.loading = false;
          if (genericFilterModel.SkipRecords === 0) {
            this.totalRecords = investment.TotalCount;
          }
          if (investment.LstnvestmentPortfolios.length > 0) {
            this.transactionData = [...this.transactionData, ...investment.LstnvestmentPortfolios];
            if (this.totalRecords === this.transactionData.length) {
              this.allDataLoadedTrans = true;
            }
          } else {
            this.allDataLoadedTrans = true;
          }
        },
        error => {
          this.loading = false;
          this.ngxService.stop();
        }
      );
  }

  sortChangeDist(sort: SortDescriptor[]): void {
    if (sort && sort[0].field === 'seqNum') {
      return;
    }
    this.sortDist = sort;
    this.loading = true;

    this.clearDistributionData();
    this.getDistributionDetails();
  }

  filterChangeDistribution(): void {
    this.clearDistributionData();
    this.getDistributionDetails();
  }

  loadMoreDist(event: any) {
    if (!this.allDataLoadedDist && !this.loading) {
      this.skipRecords = this.distributionsData.length;
      this.loading = true;
      this.getDistributionDetails();
    }
  }

  getDistributionDetails() {
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];
    genericFilterModel.Filters.push({Key: 'RollUp2', Value: this.investment.ROLLUP_SUB_2});
    const obj = {
      RollUp2: this.investment.ROLLUP_SUB_2
    };

    if (this.distSelYear && Number(this.distSelYear)) { // if we send 0, BE will return nothing
      genericFilterModel.Filters.push({Key: 'year', Value: this.distSelYear.toString()});
    }
    genericFilterModel.Filters.push({Key: 'DistributionType', Value: this.distributionType});
    genericFilterModel.PageNo = this.currentPageNoDist;
    genericFilterModel.PageSize = this.rowPerPage;
    genericFilterModel.SortField = this.sortDist[0].field;
    genericFilterModel.SortOrder = this.sortDist[0].dir;
    genericFilterModel.SkipRecords = this.skipRecords;

    this.abstractDataProvider.postData(genericFilterModel, 'api/Investment/GetDistributionsRecords')
      .subscribe((investment) => {
          this.loading = false;
          if (genericFilterModel.SkipRecords === 0) {
            this.totalRecords = investment.TotalCount;
          }
          if (investment.LstnvestmentPortfolios.length > 0) {
            this.distributionsData = [...this.distributionsData, ...investment.LstnvestmentPortfolios];
            if (this.totalRecords == this.distributionsData.length) {
              this.allDataLoadedDist = true;
            }
          } else {
            this.allDataLoadedDist = true;
          }
        },
        error => {
          this.loading = false;
          this.ngxService.stop();

          this.display = true;
          this.popupMessage =  getErrorMessageText(error);
        }
      );
  }

  openPopup(dataItem: any): void {
    this.display = true;
    this.popupMessage = [dataItem.PyeeLine1, dataItem.PyeeLine2, dataItem.PyeeLine3, dataItem.PyeeLine4, dataItem.PyeeLine5, dataItem.PyeeLine6]
      .filter(Boolean).join('<br>');
  }

  onConfirm() {
    this.display = false;
    this.popupMessage = null;
  }

  getInvestmentDetails() {
    this.investorBkrInfo = this.investment;
  }

  doAction(event: Event, action: string, dataItem: any) {
    if (!action) {
      return;
    }
    event.stopPropagation();

    switch (action) {
      case 'investment-details-popup':
        this.openPopup(dataItem);
        break;
    }
  }

  private clearTransactionData(): void {
    this.currentPageNoTrans = 1;
    this.allDataLoadedTrans = false;
    this.transactionData = [];
    this.skipRecords = 0;
  }

  private clearDistributionData(): void {
    this.currentPageNoDist = 1;
    this.allDataLoadedDist = false;
    this.distributionsData = [];
    this.skipRecords = 0;
  }
}
